import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTypedFlag } from "@/features/feature-flags/registry"
import { FilesList } from "@/features/store-files/components"
import {
  filesQuery,
  countriesQuery,
  storesQuery,
} from "@/features/store-files/core/hooks/useFilesFilters"
import { fileFiltersSchema } from "@/features/store-files/core/types/filterSchema"

export const Route = createFileRoute("/(authenticated)/files/")({
  validateSearch: fileFiltersSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient.ensureQueryData(filesQuery(deps))
    void context.queryClient.ensureQueryData(countriesQuery)
    void context.queryClient.ensureQueryData(storesQuery)
  },
  component: FilesPage,
})

function FilesPage() {
  const navigate = useNavigate({ from: Route.fullPath })
  const filters = Route.useSearch()
  const { value: showFiles, isLoading } = useTypedFlag("show-files")

  // Redirect to projects if feature is disabled
  if (!isLoading && !showFiles) {
    navigate({ to: "/projects" })
    return null
  }

  return <FilesList filters={filters} />
}
